(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["invzi-home-hero"] && !Shopify.designMode) return;
  try {
    
  if (!window.invziResearchDialogBound) {
    window.invziResearchDialogBound = true;
    const dialogOpeners = new WeakMap();

    document.addEventListener('click', (event) => {
      const openButton = event.target.closest('[data-ibh-research-open]');
      if (openButton) {
        const section = openButton.closest('[data-section-id]');
        const dialog = section && section.querySelector('[data-ibh-research-dialog]');
        if (dialog && typeof dialog.showModal === 'function') {
          dialogOpeners.set(dialog, openButton);
          dialog.showModal();
        }
        return;
      }

      const closeButton = event.target.closest('[data-ibh-research-close]');
      if (closeButton) {
        const dialog = closeButton.closest('[data-ibh-research-dialog]');
        if (dialog) dialog.close();
      }
    });

    document.addEventListener('click', (event) => {
      const dialog = event.target.closest('[data-ibh-research-dialog]');
      if (dialog && event.target === dialog) dialog.close();
    });

    document.addEventListener('close', (event) => {
      const dialog = event.target;
      if (!dialog.matches || !dialog.matches('[data-ibh-research-dialog]')) return;
      const opener = dialogOpeners.get(dialog);
      if (opener) opener.focus();
    }, true);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maghub-device-advisor"] && !Shopify.designMode) return;
  try {
    
(() => {
  function compatibility(profile, product) {
    if (profile.platform === 'console') {
      if (profile.console === 'switch_lite') return {status:'not_supported',reason:'lite_unavailable'};
      if (!['ps5','switch','xbox'].includes(profile.console)) return {status:'needs_info',reason:'console_unknown'};
      return product.driver ? {status:'not_supported',reason:'console_driver'} : {status:'supported',reason:'console_ok'};
    }
    if (!['mac','mini','windows'].includes(profile.platform)) return {status:'needs_info',reason:'os_unknown'};
    if (!product.driver) {
      if (profile.platform === 'mac' && profile.chip === 'base') return {status:'not_supported',reason:'mac_base_limit'};
      if (profile.platform === 'mac' && !['base','other'].includes(profile.chip)) return {status:'needs_info',reason:'chip_unknown'};
      return {status:'supported',reason:'free_ok'};
    }
    if (profile.platform === 'windows') {
      if (profile.os === 'older') return {status:'not_supported',reason:'win_old'};
      if (!['10','11'].includes(profile.os)) return {status:'needs_info',reason:'win_unknown'};
    } else {
      if (product.handle === 'maghub-trio-16-triple-screen-extender') return {status:'supported',reason:'driver_ok'};
      if (!profile.year) return {status:'needs_info',reason:'mac_unknown'};
      if (profile.year < 2019) return {status:'not_supported',reason:'mac_old'};
    }
    return {status:'supported',reason:'driver_ok'};
  }
  function score(product, profile) {
    let value = product.priority / 100;
    if (product.fit === profile.work) value += 12;
    if (profile.work === 'space') value += product.screens * 3 + product.size;
    if (profile.work === 'balanced' && product.screens === 3 && product.size === 16) value += 8;
    if (profile.work === 'travel' && product.screens === 2) value += 8;
    if (profile.work === 'flexible' && !product.driver) value += 8;
    if (profile.platform === 'console' && product.fit === 'flexible') value += 20;
    return value;
  }
  function shortlist(products, profile) {
    return products.filter(p => p.handle && p.available && compatibility(profile,p).status === 'supported' && (profile.driver === 'yes' || !p.driver) && (profile.budget === 'any' || p.price <= Number(profile.budget))).sort((a,b) => score(b,profile)-score(a,profile) || a.price-b.price);
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = {compatibility,score,shortlist};
  if (typeof document === 'undefined') return;
  function init(root) {
    if (root.dataset.ready) return;
    const products = JSON.parse(root.querySelector('[data-ca-products]').textContent).filter(p => p.handle);
    const catalog = JSON.parse(root.querySelector('[data-ca-devices]').textContent);
    const words = JSON.parse(root.querySelector('[data-ca-words]').textContent);
    const t = (key, values={}) => Object.entries(values).reduce((s,[name,value]) => s.replaceAll('__'+name+'__',String(value)),words[key] || key);
    const el = s => root.querySelector(s);
    const many = s => [...root.querySelectorAll(s)];
    const escape = text => String(text ?? '').replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
    let profile = {platform:'mac',chip:'',year:null,os:'',console:'',driver:'yes',work:'balanced',budget:'any',device:''};
    let chosen = null;
    let manual = false;
    let matches = [];
    const normalize = value => value.toLowerCase().replace(/["'“”().,/-]/g,' ').replace(/\s+/g,' ').trim();
    const lookup = () => catalog.find(d=>d.platform === profile.platform && normalize(d.label) === normalize(el('[data-model]').value));
    function updateDeviceFields(reset=false) {
      const platform = el('[name^="device-"]:checked').value;
      if (reset) {
        profile.platform = platform; profile.chip=''; profile.device=''; profile.year=null; profile.os=''; profile.console='';
        el('[data-model]').value=''; el('[data-chip]').value=''; el('[data-year]').value=''; el('[data-os]').value=''; el('[data-console]').value=''; manual=false;
        el('[data-error]').hidden=true;
      }
      el('[data-model-fields]').hidden=platform === 'console';
      el('[data-year-fields]').hidden=!(manual && ['mac','mini'].includes(platform));
      el('[data-chip-fields]').hidden=!(manual && platform==='mac');
      el('[data-os-fields]').hidden=platform !== 'windows';
      el('[data-console-fields]').hidden=platform !== 'console';
      el('[data-manual]').setAttribute('aria-expanded',String(manual));
      const list=el('datalist'); list.replaceChildren();
      catalog.filter(d=>d.platform === platform).forEach(d=>{const o=document.createElement('option');o.value=d.label;list.append(o);});
      const found=lookup();
      el('[data-selected]').hidden=!found;
      if(found) el('[data-selected]').textContent=t('selected',{DEVICE:found.label});
    }
    function go(step) {
      many('[data-step]').forEach(e=>e.hidden=Number(e.dataset.step)!==step);
      many('[data-progress]').forEach(e=>{if(Number(e.dataset.progress)===step)e.setAttribute('aria-current','step');else e.removeAttribute('aria-current');});
      const panel=el('[data-step="'+step+'"]');
      panel.querySelector('h2').focus({preventScroll:true});
      panel.scrollIntoView({block:'start',behavior:'instant'});
    }
    function readDevice(quiet=false) {
      const found=lookup();
      const platform=profile.platform;
      profile.device=found?.label || t(platform);
      if(platform==='console') {
        if(!el('[data-console]').value)return 'console_error';
        profile.console=el('[data-console]').value; profile.device=t(profile.console); profile.year=null;profile.os='';
      } else if(platform==='windows') {
        if(!el('[data-os]').value)return 'system_error';
        profile.os=el('[data-os]').value;profile.year=null;
        if(!found && el('[data-model]').value.trim()) profile.device=el('[data-model]').value.trim()+' · '+t('windows');
        profile.device+=' · '+(profile.os==='10'?t('win10'):profile.os==='11'?t('win11'):profile.os==='older'?t('win_other'):t('unknown'));
      } else {
        if(found && !manual){profile.year=found.year;profile.chip=/MacBook.*\bM[123]\b(?!\s*(?:Pro|Max|Ultra))/i.test(found.label)?'base':'other';}
        else {
          if(!el('[data-year]').value){if(!quiet){manual=true;updateDeviceFields();}return 'device_error';}
          profile.year=el('[data-year]').value==='new'?2019:el('[data-year]').value==='old'?2018:null;
          profile.chip=platform==='mini'||profile.year===2018?'other':el('[data-chip]').value || 'unknown';
          profile.device=t(platform)+' · '+(profile.year===2019?t('year_new'):profile.year===2018?t('year_old'):t('unknown'));
        }
      }
      el('[data-driver-field]').hidden=platform==='console';
      return null;
    }
    const badge = p => '<span class="mca-badge">'+escape(t(p.driver?'driver_required':'driver_free'))+'</span>';
    function reason(p) {
      if(profile.work==='space' && p.size===18.5)return 'reason_space';
      if(profile.work==='balanced' && p.screens===3 && p.size===16)return 'reason_balanced';
      if(profile.work==='travel' && p.screens===2)return 'reason_travel';
      if(p.fit==='flexible' && !p.driver)return 'reason_flexible';
      return profile.budget==='any'?'reason_other':'reason_budget';
    }
    function productImage(p, css='') {return p.image?'<img class="'+css+'" src="'+escape(p.image)+'" width="720" height="720" alt="'+escape(p.name)+'" loading="lazy">':'';}
    function setup(p) {
      const steps=profile.platform==='console'?['setup_console_1','setup_console_2','setup_console_3']:p.driver?['setup_driver_1','setup_driver_2','setup_driver_3']:['setup_free_1','setup_free_2','setup_free_3'];
      let html='<section class="mca-setup"><h3>'+escape(t('setup_heading'))+'</h3>';
      if(profile.platform==='console')html+='<p class="mca-note">'+escape(t('console_help'))+'</p>';
      if(p.driver && profile.platform==='mini')html+='<p class="mca-note">'+escape(t('mini_note'))+'</p>';
      html+='<details class="mca-setup-steps"><summary>'+escape(t('setup_steps'))+'</summary><ol>'+steps.map(k=>'<li>'+escape(t(k))+'</li>').join('')+'</ol>';
      if(p.driver && ['mac','mini'].includes(profile.platform))html+='<p class="mca-note">'+escape(t('setup_driver_mac'))+'</p>';
      html+='</details><div class="mca-setup-links">';
      if(p.driver) {
        const isWindows=profile.platform==='windows';
        const href=isWindows?'https://cdn.shopify.com/s/files/1/0586/1133/5353/files/MagHub_Display_Windows_Driver.exe?v=1782204810':'https://cdn.shopify.com/s/files/1/0586/1133/5353/files/MagHub_display_macOS_Driver.pkg?v=1782204706';
        html+='<a class="mca-button" href="'+href+'">'+escape(t(isWindows?'download_win':'download_mac'))+' ↓</a>';
      }
      if(p.manual)html+='<a class="mca-link" href="'+escape(p.manual)+'" target="_blank" rel="noopener">'+escape(t('manual_link'))+' ↗</a>';
      if(p.tutorial)html+='<a class="mca-link" href="'+escape(p.tutorial)+'" target="_blank" rel="noopener">'+escape(t('watch_tutorial'))+' ↗</a>';
      return html+'</div></section>';
    }
    function allStatuses() {
      return '<details class="mca-status-list"><summary>'+escape(t('show_all'))+'</summary><ul>'+products.map(p=>{
        const check=compatibility(profile,p);let extra='';
        if(check.status==='supported'){
          if(profile.driver!=='yes' && p.driver)extra=t(profile.driver==='no'?'blocked_driver':'ask_it');
          else if(!p.available)extra=t('unavailable');
          else if(profile.budget!=='any' && p.price>Number(profile.budget))extra=t('above_budget');
        }
        return '<li><strong>'+escape(p.name)+' · '+escape(p.money)+'</strong>'+escape(t(check.status))+' — '+escape(t(check.reason))+(extra?' '+escape(extra):'')+'</li>';
      }).join('')+'</ul></details>';
    }
    function syncComparison() {
      const ordered=chosen?[matches.find(p=>p.id===chosen),...matches.filter(p=>p.id!==chosen)]:matches;
      document.dispatchEvent(new CustomEvent('maghub:compare',{detail:{handles:ordered.filter(Boolean).map(p=>p.handle)}}));
    }
    function syncLive() {
      const error=readDevice(true);
      if(error) {
        many('[data-live]').forEach(e=>{e.hidden=false;e.textContent=t('live_pending');});
        document.dispatchEvent(new CustomEvent('maghub:compare',{detail:{handles:null}}));
        return;
      }
      profile.work=el('[name^="work-"]:checked').value;
      profile.driver=profile.platform==='console'?'no':el('[data-driver]').value;
      profile.budget=el('[data-budget]').value;
      chosen=null;matches=shortlist(products,profile);
      const html=matches.length?'<strong>'+escape(t('budget_count',{COUNT:matches.length}))+' · '+escape(t('live_match',{MODEL:matches[0].name}))+'</strong> <a class="mca-link" href="#maghub-compare-details">'+escape(t('live_link'))+' ↓</a>':escape(t('live_empty'));
      many('[data-live]').forEach(e=>{e.hidden=false;e.innerHTML=html;});
      syncComparison();
    }
    function renderResults() {
      matches=shortlist(products,profile);
      const p=matches.find(p=>p.id===chosen)||matches[0];
      el('[data-result-count]').textContent=t('budget_count',{COUNT:matches.length});
      el('[data-result-device]').textContent=t('result_intro',{DEVICE:profile.device});
      el('[data-compare-matches]').hidden=matches.length===0;
      let html='';
      if(p) {
        html='<article class="mca-match"><div class="mca-match-image">'+productImage(p)+'</div><div class="mca-match-copy"><span class="mca-badge">'+escape(t(chosen?'chosen':'recommended'))+'</span><h3>'+escape(p.name)+'</h3><p>'+escape(t('external',{COUNT:p.screens}))+' · '+escape(t(p.driver?'driver_required':'driver_free'))+'</p><p>'+escape(t(reason(p)))+'</p><strong class="mca-match-price">'+escape(p.money)+'</strong><a class="mca-button" href="'+escape(p.url)+'">'+escape(t('view_product'))+' →</a></div></article>'+setup(p);
        const others=matches.filter(x=>x.id!==p.id).slice(0,2);
        if(others.length)html+='<section class="mca-alternatives"><h3>'+escape(t('alternative_heading'))+'</h3><div class="mca-alt-grid">'+others.map(x=>'<article class="mca-alt">'+productImage(x)+badge(x)+'<strong>'+escape(x.name)+'</strong><p>'+escape(t('external',{COUNT:x.screens}))+'</p><strong>'+escape(x.money)+'</strong><button class="mca-link" type="button" data-pick="'+escape(x.id)+'">'+escape(t('select_model'))+'</button></article>').join('')+'</div></section>';
      } else html='<div class="mca-empty"><h3>'+escape(t('no_match'))+'</h3><p>'+escape(t('no_match_body'))+'</p><button class="mca-link" type="button" data-back="1">'+escape(t('edit'))+'</button></div>';
      if(profile.driver==='unknown')html+='<p class="mca-note">'+escape(t('ask_it'))+'</p>';
      if(profile.driver==='no' && profile.platform!=='console')html+='<p class="mca-note">'+escape(t('no_driver_limit'))+'</p>';
      html+=allStatuses();el('[data-result]').innerHTML=html;syncComparison();
    }
    many('[name^="device-"]').forEach(e=>e.addEventListener('change',()=>updateDeviceFields(true)));
    el('[data-model]').addEventListener('input',()=>{manual=false;el('[data-year]').value='';updateDeviceFields();});
    el('[data-manual]').addEventListener('click',()=>{manual=!manual;updateDeviceFields();if(profile.platform==='windows')el('[data-os]').focus();else el('[data-year]').focus();});
    el('[data-next]').addEventListener('click',()=>{const error=readDevice();el('[data-error]').hidden=!error;if(error){el('[data-error]').textContent=t(error);return;}go(1);});
    el('[data-results]').addEventListener('click',()=>{profile.work=el('[name^="work-"]:checked').value;profile.driver=profile.platform==='console'?'no':el('[data-driver]').value;profile.budget=el('[data-budget]').value;chosen=null;renderResults();go(2);});
    root.addEventListener('click',event=>{
      const back=event.target.closest('[data-back]');if(back)go(Number(back.dataset.back));
      const pick=event.target.closest('[data-pick]');if(pick){chosen=pick.dataset.pick;renderResults();go(2);}
    });
    el('[data-restart]').addEventListener('click',()=>{el('[name^="device-"][value="mac"]').checked=true;el('[name^="work-"][value="balanced"]').checked=true;el('[data-driver]').value='yes';el('[data-budget]').value='any';profile={platform:'mac',chip:'',year:null,os:'',console:'',driver:'yes',work:'balanced',budget:'any',device:''};chosen=null;updateDeviceFields(true);many('[data-live]').forEach(e=>e.hidden=true);document.dispatchEvent(new CustomEvent('maghub:compare',{detail:{handles:null}}));go(0);});
    el('[data-compare-matches]').addEventListener('click',()=>{
      const ordered=chosen?[matches.find(p=>p.id===chosen),...matches.filter(p=>p.id!==chosen)]:matches;
      document.dispatchEvent(new CustomEvent('maghub:compare',{detail:{handles:ordered.filter(Boolean).map(p=>p.handle)}}));
      const table=document.getElementById('maghub-compare-details');
      if(table){table.scrollIntoView({block:'start',behavior:'instant'});table.querySelector('select')?.focus({preventScroll:true});}
    });
    root.addEventListener('change',event=>{if(event.target.matches('input,select'))syncLive();});
    el('[data-model]').addEventListener('input',syncLive);
    const prices=[...new Set(products.filter(p=>p.available).map(p=>p.price))].sort((a,b)=>a-b);
    prices.forEach(price=>{const p=products.find(p=>p.price===price);const o=document.createElement('option');o.value=String(price);o.textContent=t('up_to',{PRICE:p.money.replace(/^From /,'')});el('[data-budget]').append(o);});
    updateDeviceFields();root.dataset.ready='true';el('[data-ca-flow]').hidden=false;
  }
  document.querySelectorAll('[data-maghub-advisor]').forEach(init);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-maghub-advisor]').forEach(init));
})();


  } catch(e) { console.error(e); }
})();
})();
